import { createContext } from 'react';

export const LabelContext = createContext({});

export default LabelContext;
